// extracted by mini-css-extract-plugin
module.exports = {"table":"AdminAssets_table__2xuaG","deploySuccess":"AdminAssets_deploySuccess__2fVNb"};